"use strict";
/**
 * 文字处理
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.numbericFormat = void 0;
function numbericFormat(data) {
    var item = parseFloat(data);
    if (!isNaN(item)) {
        if (item < 0)
            item = item * -1;
        if ((item > 0 && item < 1e4) || (item < 0 && item > -1e4)) {
            return (item).toString();
        }
        else if ((item > 0 && item < 1e6) || (item < 0 && item > -1e6)) {
            item = item / 10000;
            return item.toFixed(2) + "万";
        }
        else if ((item > 0 && item < 1e7) || (item < 0 && item > -1e7)) {
            item = item / 10000;
            return item.toFixed(1) + "万";
        }
        else if ((item > 0 && item < 1e8) || (item < 0 && item > -1e8)) {
            item = item / 10000;
            return item.toFixed(0) + "万";
        }
        else if ((item > 0 && item < 1e10) || (item < 0 && item > -1e10)) {
            item = item / 1e8;
            return item.toFixed(2) + "亿";
        }
        else if ((item > 0 && item < 1e11) || (item < 0 && item > -1e11)) {
            item = item / 1e8;
            return item.toFixed(1) + "亿";
        }
        else if ((item > 0 && item < 1e12) || (item < 0 && item > -1e12)) {
            item = item / 1e8;
            return item.toFixed(0) + "亿";
        }
        else if ((item > 0 && item < 1e14) || (item < 0 && item > -1e14)) {
            item = item / 1e12;
            return item.toFixed(2) + "万亿";
        }
        else if ((item > 0 && item < 1e16) || (item < 0 && item > -1e16)) {
            item = item / 1e12;
            return item.toFixed(1) + "万亿";
        }
        else {
            return item;
        }
    }
    return '-';
}
exports.numbericFormat = numbericFormat;
